import { useTimeZone } from '../../../../../hooks'
import { useNewsboardPostProfileContext } from '../../../Newsboard.hooks'
import {
  getNewsboardPostProfileEditTimeRangeActionTypes,
  getNewsboardPostProfileEditTimeRangeInitialValues,
  getNewsboardPostProfileEditTimeRangePayload,
  getNewsboardPostProfileEditTimeRangeValidationSchema,
  NewsboardPostProfileEditTimeRangeModal,
} from '../../../NewsboardPostProfileEditTimeRangeModal'

export function useNewsboardPostProfileEditTimeRange() {
  const timezone = useTimeZone()

  const { handleCloseModal, handleUpdateEntity, postData, setModal } =
    useNewsboardPostProfileContext()

  async function handleSubmit({ values }) {
    await handleUpdateEntity(
      getNewsboardPostProfileEditTimeRangePayload({ timezone, values })
    )
    handleCloseModal()
  }

  function handleOpenModal() {
    setModal(
      <NewsboardPostProfileEditTimeRangeModal
        formFieldsProps={{
          actionTypes: getNewsboardPostProfileEditTimeRangeActionTypes(),
        }}
        initialValues={getNewsboardPostProfileEditTimeRangeInitialValues({
          dateFrom: postData?.date_from,
          dateTo: postData?.date_to,
          timezone,
        })}
        validationSchema={getNewsboardPostProfileEditTimeRangeValidationSchema()}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />
    )
  }

  return { handleOpenModal }
}
